'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var Mission = function Mission() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Mission | Doctify',
				pageDescription: 'The background to how Doctify started. Rate, review and book doctors and specialists online',
				pagePath: (0, _doctifyUtils.getResourcePath)('/mission')
			},
			_react2.default.createElement(
				'h1',
				null,
				'Mission'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Our story'
			),
			_react2.default.createElement(
				'p',
				null,
				'The idea for Doctify started when one of our founders, Stephanie, was lost when she was trying to find a doctor for herself. Despite working as a surgeon in London, she was unsure where to find a doctor that specialised in treating her particular concern. She felt that relying on word of mouth or a simple search result on Google couldn\'t be the only answer to finding the right doctor. She turned to her best friend, Suman, also a doctor, and so began the start of their journey to find a solution that would ultimately help other people in similar situations. The dream of creating a platform that would bring together patients and doctors was born. Driven by Stephanie\u2019s and Suman\u2019s vision, we at Doctify are passionate about helping patients to find the right specialist by providing them with the right guidance and information.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Our mission'
			),
			_react2.default.createElement(
				'p',
				null,
				'Rooted in our experience and understanding of both the personal and professional sides of healthcare, we are driven by a passionate belief that technology can greatly enhance the relationship between patients and health specialists. We are working on making our patients\u2019 lives easier and our health specialists\u2019 interactions more fulfilling. We are striving to continuously nurture and improve the understanding between patients and health specialists \u2013 because a better relationship can only make for better health. Stephanie: "London has some of the very best health specialists in the UK and it is our dream to bring patients and doctors together. Our health is the most precious thing we have. We want to help people find the right health specialist, and provide them with the right guidance when they need it most."'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Our solution'
			),
			_react2.default.createElement(
				'p',
				null,
				'Studies have shown that 9 out of 10 patients choose their doctors after having read reviews. At Doctify, we strongly believe in the benefit of patient reviews and the dual role they play: empowering people to make informed decisions and recognising the exceptional dedication of doctors and health specialists. The specialty, specific expertise and patient reviews are important factors in the decision-making process of a patient when selecting a doctor. However, as our lives get busier, location and availability are also very important considerations that patients take into account. Online booking tools will allow patients to book appointments from any device, 24-hours a day. These tools will also allow patients to see the next available doctor when an urgent appointment is required. Stephanie and Suman are committed to helping doctors manage their online presence through an independent, transparent and trusted site that represents their values and beliefs.'
			)
		)
	);
};

Mission.displayName = 'BasicTextPage';

Mission.defaultProps = {};

exports.default = Mission;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/mission-page.js